import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/unsubscribe`;

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/${token}`).then((r) => { setInfo(r.data); setDone(r.data.suppressed); }).catch(() => setErr("This link is not recognised.")); }, [token]);
  const go = async () => { try { await axios.post(`${API}/${token}`); setDone(true); } catch { setErr("Something went wrong. Please try again."); } };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#0A0A0A]">
      <div className="max-w-md w-full border border-border bg-[#121212] rounded-md p-8" data-testid="unsubscribe-page">
        <div className="font-display text-lg font-extrabold mb-6">{info?.company || "Specia"}</div>
        {err ? <p className="text-sm text-[#FF6961]">{err}</p> : !info ? <p className="text-sm text-zinc-500">Loading…</p> : done ? (
          <><h1 className="text-2xl font-extrabold">You're unsubscribed.</h1><p className="text-sm text-zinc-400 mt-3" data-testid="unsubscribe-done">{info.email_masked} will receive no further marketing from {info.company}. This takes effect immediately.</p></>
        ) : (
          <><h1 className="text-2xl font-extrabold">Stop these emails?</h1><p className="text-sm text-zinc-400 mt-3">Unsubscribe {info.email_masked} from all marketing from {info.company}.</p>
            <Button data-testid="unsubscribe-confirm-btn" onClick={go} className="mt-6 w-full bg-[#FF3B30] hover:bg-[#FF6961]">Unsubscribe</Button></>
        )}
      </div>
    </div>
  );
}
